import React from 'react'
import { useQueryParams } from '@fs/zion-router'
import GroupData from '../../views/imageBrowse/groupData/GroupData'
import ImageQualityAuditInfoSheet from '../../views/imageQualityAudit/ImageQualityAuditInfoSheet'
import MetadataAuditInfoSheet from '../../views/metadataAudit/MetadataAuditInfoSheet'

const SideSheetBody = () => {
  const { query } = useQueryParams()
  const { mode, view } = query

  if (mode === 'metadataAudit') return <MetadataAuditInfoSheet />
  if (mode === 'imageQualityAudit') return <ImageQualityAuditInfoSheet />
  if (mode === 'DIVIDE') return <GroupData />

  return (
    <>
      {view === 'organize' && <GroupData />}
      {(!view || view === 'explore') && <GroupData />}
    </>
  )
}

export default SideSheetBody
